import { sva } from "@stubhub/broadway-foundation/css";

export const performerEventGridListItemRecipeVariables = {
  seasonTicketIconPrimaryColor: "--component-season-ticket-icon-primary-color",
} as const satisfies Record<string, `--component-${string}`>;

export const performerEventGridListItemSlots = [
  "listItem",
  "seasonTicketIcon",
  "seasonTicketIconContainer",
] as const;

export const performerEventGridListItemRecipe = sva({
  slots: performerEventGridListItemSlots,
  className: "performerEventGridListItem",
  base: {
    listItem: {},
    seasonTicketIcon: {
      color: "var(--component-season-ticket-icon-primary-color)",
    },
    seasonTicketIconContainer: {
      width: "[64px]",
      height: "[64px]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      borderBlockWidth: "primitives.25",
      borderInlineWidth: "primitives.25",
      borderBlockColor: "border",
      borderInlineColor: "border",
      borderStartRadius: "element.default",
      borderEndRadius: "element.default",
      backgroundColor: "bg",
    },
  },
});
